import React from 'react';
import { Check } from 'lucide-react';

// "¿Qué árbol?" / "¿Qué cable?" de un ítem en Alerta o Falla: un chip por
// elemento activo de la instalación (código y un texto corto), varios a la
// vez. Un id elegido que ya no está en la lista (dado de baja, o la lista no
// cargó en una corrección) se sigue mostrando elegido para poder quitarlo.
//   elementos    [{ id, codigo, secundario }]
//   elegidos     [id]
//   obligatorio  true cuando hay elementos cargados (el resumen lo exige)
//   textos       { pregunta, falta, fuera }  (fuera: chip de un id huérfano)
//   icono        ícono de lucide del chip sin elegir
//   atributo     data-* del chip (data-arbol, data-linea)
export default function ElegirElementos({
  elementos, elegidos, onCambiar, obligatorio, idBase, sufijo, textos, icono: Icono, atributo,
}) {
  const sel = new Set(elegidos || []);
  const conocidos = new Set(elementos.map((a) => a.id));
  const huerfanos = (elegidos || []).filter((id) => !conocidos.has(id));
  const alternar = (id) => {
    const n = sel.has(id) ? (elegidos || []).filter((x) => x !== id) : [...(elegidos || []), id];
    onCambiar(n);
  };
  const idTitulo = `${idBase}-${sufijo}`;
  const falta = obligatorio && sel.size === 0;

  const chip = (id, principal, secundario) => {
    const activo = sel.has(id);
    return (
      <button
        key={id}
        type="button"
        aria-pressed={activo}
        aria-label={secundario ? `${principal} · ${secundario}` : principal}
        {...{ [atributo]: id }}
        onClick={() => alternar(id)}
        style={{ touchAction: 'manipulation' }}
        className={`flex min-h-[56px] items-center gap-2 rounded-2xl border-2 px-4 text-left text-base font-semibold transition-colors duration-150 ${
          activo ? 'border-primary bg-primary text-white' : 'border-border bg-white text-foreground'
        }`}
      >
        {activo
          ? <Check size={20} strokeWidth={3} aria-hidden="true" className="shrink-0" />
          : <Icono size={20} aria-hidden="true" className="shrink-0 text-primary" />}
        <span>
          <span className="font-bold">{principal}</span>
          {secundario ? <span className="font-normal"> · {secundario}</span> : null}
        </span>
      </button>
    );
  };

  return (
    <div className="mt-4">
      <p id={idTitulo} className="text-base font-semibold text-foreground">{textos.pregunta}</p>
      <p className={`mt-0.5 text-sm text-foreground ${falta ? 'font-bold' : ''}`}>
        {falta ? textos.falta : 'Puede elegir varios.'}
      </p>
      <div role="group" aria-labelledby={idTitulo} className="mt-2 flex flex-wrap gap-2">
        {elementos.map((a) => chip(a.id, a.codigo, a.secundario))}
        {huerfanos.map((id) => chip(id, textos.fuera, 'tóquelo para quitarlo'))}
      </div>
    </div>
  );
}
